import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { APP_VERSION } from 'ziphy-web-shared/basic/helpers';
import CautionNotice from '@library/widgets/cautionNotice/CautionNotice';
import AuthTosText from '@nedoShared/modules/auth/AuthTosText';
import LoginForm from '@nedoShared/modules/auth/LoginForm';
import mainConfig from '@config/main';
import { routeActions } from '@config/routeActions';
import appLogoZiphy from '@assets/images/app-logo.svg';
import providerLogoKerna from '@assets/images/kernadoc.svg';
import clientLogoKerna from '@assets/images/my-kernahealth.svg';
import styles from './LoginPage.module.scss';
import { useSelectedBrand } from '@core/src/hooks/useSelectedBrand';
const LoginPage = ({ waitAllConfigureSteps }) => {
    const { t } = useTranslation();
    const { isZiphy } = useSelectedBrand();
    const isProvider = window.location.pathname.includes('provider');
    let appLogo = appLogoZiphy;
    if (!isZiphy) {
        appLogo = isProvider ? providerLogoKerna : clientLogoKerna;
    }
    return (_jsxs("div", Object.assign({ className: styles.wrapper }, { children: [_jsx("div", Object.assign({ className: styles.header }, { children: _jsx("img", { src: appLogo, className: styles.logo, alt: "" }) })), _jsx("div", Object.assign({ className: styles.body }, { children: _jsx(LoginForm, { redirectAfterComplete: routeActions.HOME(), waitAllConfigureSteps: waitAllConfigureSteps }) })), _jsxs("div", Object.assign({ className: styles.footer }, { children: [_jsx(AuthTosText, {}), _jsx("div", Object.assign({ className: "mt-10" }, { children: t('version', { number: APP_VERSION }) }))] })), mainConfig.custom.staffLoginCautionNotice && (_jsx(CautionNotice, { show: true, title: t('caution_notice.hipaa.title'), message: t('caution_notice.hipaa.message') }))] })));
};
export default observer(LoginPage);
